import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EventIcon from "@mui/icons-material/Event";
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { message, Tag } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import { getMobilePage } from "../../utils/ApiCalls/AddMobilePage";
import { getShipMobilePage } from "../../utils/ApiCalls/AddShipMobilePage";
import {
  createDailyPlannerPages,
  deleteDailyPlannerData,
  getSingleWeeklyPlannerData,
  bulkDeletePageSchedule,
} from "../../utils/ApiCalls/DailyPlanner";
import { addlog } from "../../utils/ApiCalls/Logs";
import { getCategoryOption } from "../../utils/ApiCalls/Mobile/ActivityMasters";
import {
  getSailingPageData,
  updateSailingPageData,
} from "../../utils/ApiCalls/SailingData";
import { DAILY_PLANNER_LOG_TYPES, createPlannerTitle } from "../../constants/logging/dailyPlanner";
import SearchBar from "../SearchField/SearchBar";
import CustomizedData from "../UI/CustomizedData";
const DailyPlannerPageSelector = ({
  vessel_id,
  sailing_date,
  vesselOptions,
  sailing_id,
  sailing_page,
  dailyPlannerData,
  onScheduleRemovalReady,
}) => {
  const [availablePagesList, setAvailablePagesList] = useState([]);
  const [availablePagesList3, setAvailablePagesList3] = useState([]);
  const [mode, setMode] = useState("duplicate");
  const navigate = useNavigate();
  const [activeCat, setActiveCat] = useState("all");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [newPagesSelected, setNewPagesSelected] = useState([]);
  const [newDuplicatePageSelected, setNewDuplicatePagesSelected] = useState([]);

  const [copySailingDate, setCopySailingDates] = useState();
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(0);
  const [activeCat2, setActiveCat2] = useState("all");
  const [page2, setPage2] = useState(1);
  const [pageSize2, setPageSize2] = useState(10);
  const [search2, setSearch2] = useState("");
  const [count2, setCount2] = useState(0);
  const [activeCat3, setActiveCat3] = useState("all");
  const [page3, setPage3] = useState(1);
  const [selectedDays, setSelectedDays] = useState([]);
  const [timeSlots, setTimeSlots] = useState([{}]);

  const days = [
    { id: 1, label: "Day 1 (24th July 2025)" },
    { id: 2, label: "Day 2 (25th July 2025)" },
    { id: 3, label: "Day 3 (26th July 2025)" },
    { id: 4, label: "Day 4 (27th July 2025)" },
    { id: 5, label: "Day 5 (28th July 2025)" },
    { id: 6, label: "Day 6 (29th July 2025)" },
    { id: 7, label: "Day 7 (30th July 2025)" },
    { id: 8, label: "Day 8 (31st July 2025)" },
  ];

  const [pageSize3, setPageSize3] = useState(10);
  const [search3, setSearch3] = useState("");
  const [activeDay, setActiveDay] = useState(1);
  const [copysailingDates, setCopySailingDate] = useState();
  const [count3, setCount3] = useState(0);
  const [categoriesOption, setactivitycategoryOption] = useState([]);
  const [{ userDetails }, dispatch] = useDataLayerValue();
  const [assignedPages, setAssignedPages] = useState([]);
  const [checkedItem, setCheckedItem] = useState();
  const extraDuration = dailyPlannerData?.extraDuration || 0;
  const sailingPageDuration = sailing_page?.duration ? sailing_page.duration + 1 + extraDuration : sailing_page?.duration;
  useEffect(() => {
    if (sailing_date) {
      setCopySailingDates(sailing_page?.package_id);
    }
  }, [sailing_date]);
  const handleAssign = async (page) => {
    clearFields(page);
  };

  useEffect(() => {
    getOptionLocation();
  }, []);

  // Pass the removal function to parent component
  useEffect(() => {
    if (onScheduleRemovalReady && typeof onScheduleRemovalReady === 'function') {
      onScheduleRemovalReady(removeScheduledActivitiesForExtraDays);
    }
  }, [assignedPages, extraDuration, sailing_date, sailing_page?.duration]);

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let activity = await getCategoryOption({
      vessel_id: vessel_id,
      limit: 1000,
    });
    let sailing = await getSailingPageData({
      vessel_id: vessel_id,
      limit: 1000,
    });
    if (activity.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: activity.error,
      });
    } else {
      setactivitycategoryOption(activity?.data);
      setCopySailingDate(sailing?.data);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  const toggleDay = (id) => {
    setSelectedDays((prev) =>
      prev.includes(id) ? prev.filter((d) => d !== id) : [...prev, id]
    );
  };

  // const selectAll = () => {
  //   if (selectedDays.length === days.length) {
  //     setSelectedDays([]);
  //   } else {
  //     setSelectedDays(days.map((d) => d.id));
  //   }
  // };

  //REPLACED THIS ONE WITH THE ABOVE FN, TO SELECT ALL DATES BASED ON DURATION --------------------
  //KEEPING THE OLD ONE COMMENTED FOR REFERENCE | IMPACT ANALYSIS -----
  const selectAll = () => {
    const allDates = Array(sailingPageDuration)
      .fill()
      .map((_, index) =>
        moment(sailing_date).add(index, "days").format("YYYY-MM-DD")
      );
    if (selectedDays.length === allDates.length) {
      setSelectedDays([]);
    } else {
      setSelectedDays(allDates);
    }
  };

  const handleRemove = async (id) => {
    // Find activity details before deletion for logging
    const activityToDelete = assignedPages
      ?.flatMap(day => day.hourlySlots?.flatMap(slot => slot.schedule || []))
      ?.find(activity => activity.scheduleId === id);
    
    const result = await deleteDailyPlannerData(id);
    if (!result?.error) {
      const vesselName = vesselOptions.find(v => v.id === vessel_id)?.name || "Unknown Vessel";
      const plannerTitle = createPlannerTitle(sailing_date, sailing_page?.duration);
      
      await addlog(
        DAILY_PLANNER_LOG_TYPES.ACTIONS.ACTIVITY_REMOVED,
        DAILY_PLANNER_LOG_TYPES.MODULE,
        {
          title: `Activity "${activityToDelete?.pageName || activityToDelete?.venueName || 'Unknown Activity'}" removed from ${plannerTitle}`,
          action: DAILY_PLANNER_LOG_TYPES.ACTION_TYPES.ACTIVITY_REMOVE,
          planner_title: plannerTitle,
          planner_id: sailing_page?.id,
          schedule_id: id,
          activity_name: activityToDelete?.pageName || activityToDelete?.venueName,
          activity_time: activityToDelete ? `${activityToDelete.startTime} - ${activityToDelete.endTime}` : null,
          vessel_name: vesselName,
          sailing_date: sailing_date
        },
        userDetails.id
      );
    }
    await getDataBySailing();
  };

  const removeScheduledActivitiesForExtraDays = async (newExtraDays) => {
    try {
      // Calculate which days will be removed
      const baseDuration = sailing_page?.duration || 0;
      const currentTotalDuration = baseDuration + 1 + extraDuration;
      const newTotalDuration = baseDuration + 1 + newExtraDays;
      
      // Generate all current dates and new dates to find the difference
      const allCurrentDates = Array(currentTotalDuration)
        .fill()
        .map((_, index) => moment(sailing_date).add(index, "days").format("YYYY-MM-DD"));
        
      const allNewDates = Array(newTotalDuration)
        .fill()
        .map((_, index) => moment(sailing_date).add(index, "days").format("YYYY-MM-DD"));
      
      // Find dates that will be removed
      const datesToRemove = allCurrentDates.filter(date => !allNewDates.includes(date));
      
      if (datesToRemove.length === 0) {
        return { success: true, message: "No dates to remove" };
      }
      
      // Find scheduleIds for activities on the dates being removed using assignedPages data
      const scheduleIdsToDelete = [];
      
      assignedPages?.forEach(dayData => {
        // Format the date from assignedPages to match our comparison format
        const dayDataFormatted = moment(dayData.date).format("YYYY-MM-DD");
        
        if (datesToRemove.includes(dayDataFormatted)) {
          // Get all schedule IDs for this day
          dayData.hourlySlots?.forEach(slot => {
            slot.schedule?.forEach(activity => {
              if (activity.scheduleId) {
                scheduleIdsToDelete.push(activity.scheduleId);
              }
            });
          });
        }
      });
      
      // Delete the scheduled activities if any exist
      if (scheduleIdsToDelete.length > 0) {
        const deleteResult = await bulkDeletePageSchedule({
          scheduleIds: scheduleIdsToDelete
        });
        
        if (deleteResult.error) {
          console.error("Failed to delete scheduled activities:", deleteResult.error);
          return { success: false, error: deleteResult.error };
        } else {
          // Refresh the data to reflect changes
          await getDataBySailing();
          return { success: true, deletedCount: scheduleIdsToDelete.length };
        }
      } else {
        return { success: true, message: "No scheduled activities found on extra days" };
      }
    } catch (error) {
      console.error("Error removing scheduled activities for extra days:", error);
      return { success: false, error: error.message };
    }
  };

  useEffect(() => {
    getData();
  }, [page, pageSize, search, activeCat, vessel_id]);

  useEffect(() => {
    getDataBySailing();
  }, [page2, pageSize2, search2, activeCat2, vessel_id]);

  const getTime = (time24) => {
    return moment(time24, "HH:mm:ss").format("hh:mm A");
  };
  const getData = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let dataQuery = {
      vessel_id: vessel_id,
      search: search,
      page: page,
      limit: pageSize,
    };
    if (activeCat !== "all") {
      dataQuery.catergory_id = activeCat;
    }
    let data = await getMobilePage(dataQuery);
    setAvailablePagesList(data.data);
    setCount(data?.count);

    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  useEffect(() => {
    if (copySailingDate && copySailingDate !== "") getData2();
  }, [page3, pageSize3, search3, activeCat3, copySailingDate]);
  const getData2 = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let dataQuery = {
      vessel_id: vessel_id,
      package_id: copySailingDate,
      search: search3,
      page: page3,
      limit: pageSize3,
    };
    if (activeCat3 !== "all") {
      dataQuery.catergory_id = activeCat3;
    }
    let data = await getShipMobilePage(dataQuery);
    setAvailablePagesList3(data.data);
    setCount3(data?.count);

    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };

  const getDataBySailing = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let dataQuery = {
      sailing_date: sailing_date,
      search: search2,
      page: page2,
      vessel_id: vessel_id,
      limit: pageSize2,
    };
    if (activeCat2 !== "all") {
      dataQuery.catergory_id = activeCat2;
    }
    let data = await getSingleWeeklyPlannerData(sailing_page?.id);
    setAssignedPages(data.data);

    setCount2(data?.count);

    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  const addTimeSlot = () => {
    setTimeSlots([...timeSlots, { startTime: "", endTime: "" }]);
  };

  const removeTimeSlot = (index) => {
    setTimeSlots(timeSlots.filter((_, i) => i !== index));
  };
  const draftSailing = async () => {
    let res = await updateSailingPageData(sailing_id, { status: "draft" });
    if (res.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: res.error,
      });
    } else {
      const vesselName = vesselOptions.find(v => v.id === vessel_id)?.name || "Unknown Vessel";
      const plannerTitle = createPlannerTitle(sailing_date, sailing_page?.duration);
      
      await addlog(
        DAILY_PLANNER_LOG_TYPES.ACTIONS.STATUS_UPDATED,
        DAILY_PLANNER_LOG_TYPES.MODULE,
        {
          title: `${plannerTitle} saved as Draft`,
          action: DAILY_PLANNER_LOG_TYPES.ACTION_TYPES.STATUS_DRAFT,
          planner_title: plannerTitle,
          planner_id: sailing_page?.id,
          new_status: "Draft",
          vessel_name: vesselName,
          sailing_date: sailing_date
        },
        userDetails.id
      );
      
      message.success("Sailing data saved as Draft");
    }
  };
  const handleAddData = async (selectedDays) => { //THIS IS THE FN ---
    let allDates = Array(sailingPageDuration)
      .fill()
      .map((item, index) =>
        moment(sailing_date).add(index, "days").format("YYYY-MM-DD")
      );
    let dataValue = {
      dailyPlannerId: sailing_page?.id,
      pages: [
        {
          pageId: checkedItem?.id,
          dailySchedule: selectedDays?.map((item) => ({
            day: allDates.findIndex((val) => val == item) + 1 || 0,
            date: item,
            timeSlots: timeSlots,
          })),
        },
      ],
    };
    console.log({ dataValue, allDates });
    let res = await createDailyPlannerPages(dataValue);
    if (res.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: res.error,
      });
    } else {
      const vesselName = vesselOptions.find(v => v.id === vessel_id)?.name || "Unknown Vessel";
      const plannerTitle = createPlannerTitle(sailing_date, sailing_page?.duration);
      const activityName = checkedItem?.shorePage?.title || checkedItem?.shorePage?.venue?.name || "Unknown Activity";
      const timeSlotsSummary = timeSlots.map(slot => `${slot.startTime}-${slot.endTime}`).join(", ");
      const daysList = selectedDays.map(date => `Day ${allDates.findIndex(d => d === date) + 1} (${moment(date).format("DD MMM")})`).join(", ");
      
      await addlog(
        DAILY_PLANNER_LOG_TYPES.ACTIONS.ACTIVITY_SCHEDULED,
        DAILY_PLANNER_LOG_TYPES.MODULE,
        {
          title: `Activity "${activityName}" scheduled in ${plannerTitle}`,
          action: DAILY_PLANNER_LOG_TYPES.ACTION_TYPES.ACTIVITY_ADD,
          planner_title: plannerTitle,
          planner_id: sailing_page?.id,
          page_id: checkedItem?.id,
          activity_name: activityName,
          scheduled_days: daysList,
          time_slots: timeSlotsSummary,
          days_count: selectedDays.length,
          time_slots_count: timeSlots.length,
          vessel_name: vesselName,
          sailing_date: sailing_date
        },
        userDetails.id
      );
      
      message.success("Page Added");
      getDataBySailing();
      clearFields();
    }
  };
  const clearFields = (page) => {
    setCheckedItem(page);
    setSelectedDays([]);
    setTimeSlots([{}]);
  };
  const publishSailing = async () => {
    let res = await updateSailingPageData(sailing_id, { status: "active" });
    if (res.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: res.error,
      });
    } else {
      const vesselName = vesselOptions.find(v => v.id === vessel_id)?.name || "Unknown Vessel";
      const plannerTitle = createPlannerTitle(sailing_date, sailing_page?.duration);
      
      await addlog(
        DAILY_PLANNER_LOG_TYPES.ACTIONS.STATUS_UPDATED,
        DAILY_PLANNER_LOG_TYPES.MODULE,
        {
          title: `${plannerTitle} published as Active`,
          action: DAILY_PLANNER_LOG_TYPES.ACTION_TYPES.STATUS_ACTIVE,
          planner_title: plannerTitle,
          planner_id: sailing_page?.id,
          new_status: "Active",
          vessel_name: vesselName,
          sailing_date: sailing_date
        },
        userDetails.id
      );
      
      message.success("Sailing data published");
    }
  };
  return (
    <Box>
      {/* <Box
        display="flex"
        sx={{
          justifyContent: "flex-end",
          paddingRight: 2,
          gap: "10px",
          marginTop: "10px",
        }}
      >
        <Button onClick={draftSailing} variant="contained">
          Save As Draft
        </Button>
        <Button onClick={publishSailing} variant="outlined">
          Publish
        </Button>
      </Box> */}
      <Box display="flex" gap={4} p={2}>
        {mode == "duplicate" && (
          <Box sx={{ border: "1px solid lightgray" }} p={2} flex={1}>
            <Typography variant="title" fontWeight="bold">
              Search Activity Library
            </Typography>

            <SearchBar
              value={search3}
              SearchValue={() => {
                setPage3(1);
              }}
              setValue={(e) => {
                setSearch3(e.target.value);
              }}
            />
            <Typography variant="title" fontWeight="bold">
              Filter by Category
            </Typography>

            <Select
              fullWidth
              size="small"
              value={activeCat3}
              onChange={(e) => setActiveCat3(e.target.value)}
              defaultValue="all"
              sx={{ mb: 2 }}
            >
              <MenuItem value="all">All Categories</MenuItem>
              {categoriesOption?.map((item) => {
                return (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </Select>

            <CustomizedData
              setRows={setAvailablePagesList3}
              setPageSize={setPageSize3}
              setPage={setPage3}
              pageSize={pageSize3}
              page={page3}
              count={count3}
              columns={[]}
              rows={availablePagesList3}
              sortHandler={() => { }}
              render={(page, index) => (
                <Card
                  key={index}
                  variant="outlined"
                  sx={{
                    mb: 2,
                    border: "1px solid black",
                    cursor: "pointer",
                    "&:hover": { bgcolor: "grey.100" },
                  }}
                  onClick={() => handleAssign(page)}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      p: 1,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box>
                        <Typography>
                          {page?.shorePage?.title ||
                            page?.shorePage?.venue?.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {page.category}
                        </Typography>
                        <Tag color={"red"}>
                          {
                            categoriesOption?.find(
                              (item) => item.id == page?.shorePage?.catergory_id
                            )?.name
                          }
                        </Tag>{" "}
                        <Tag>{page?.shorePage?.child_category?.name}</Tag>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              )}
              title={"Cabin Bookings"}
            />
          </Box>
        )}

        <Box sx={{ border: "1px solid lightgray" }} p={2} flex={1}>
          <Box
            sx={{
              width: "100%",
              alignItems: "center",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold">
              Schedule Activity
            </Typography>
            {checkedItem && (
              <Button variant="outlined" onClick={() => setCheckedItem()}>
                Clear
              </Button>
            )}
          </Box>
          {!checkedItem && (
            <Box>
              <Box
                sx={{
                  width: "100%",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                  marginTop: "100px",
                }}
              >
                <EventIcon style={{ fontSize: "100px" }} />
                <p variant="subtitle1" fontWeight="bold">
                  Select an activity to schedule
                </p>
              </Box>
            </Box>
          )}
          {checkedItem && (
            <Box>
              <Card
                variant="outlined"
                sx={{ mb: 2, border: "1px solid black", marginTop: "20px" }}
              >
                <CardContent
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    p: 1,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box>
                      <Typography>
                        {checkedItem?.shorePage?.title ||
                          checkedItem?.shorePage?.venue?.name}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {checkedItem.category}
                      </Typography>
                      <Tag color={"red"}>
                        {
                          categoriesOption?.find(
                            (item) =>
                              item.id == checkedItem?.shorePage?.catergory_id
                          )?.name
                        }
                      </Tag>{" "}
                      <Tag>{checkedItem?.shorePage?.child_category?.name}</Tag>
                    </Box>
                  </Box>
                </CardContent>
              </Card>

              <Box sx={{}}>
                {/* Schedule Days */} {/* THIS IS WHERE THINGS NEED TO BE CHANGED --- */}
                <Box mb={2}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography variant="subtitle1" fontWeight="bold">
                      Schedule Days
                    </Typography>
                    <Button variant="outlined" size="small" onClick={selectAll}>
                      {selectedDays.length === sailingPageDuration
                        ? "Unselect All"
                        : "Select All"}
                    </Button>
                  </Box>

                  <Grid container spacing={1} mt={1}>
                    {Array(sailingPageDuration)
                      .fill()
                      .map((day, index) => (
                        <Grid item xs={6} key={index}>
                          <Box
                            onClick={() =>
                              toggleDay(
                                moment(sailing_date)
                                  .add(index, "days")
                                  .format("YYYY-MM-DD")
                              )
                            }
                            style={{
                              border: "1px solid black",

                              background: selectedDays.includes(
                                moment(sailing_date)
                                  .add(index, "days")
                                  .format("YYYY-MM-DD")
                              )
                                ? "lightgray"
                                : "white",

                              padding: "10px",
                              borderRadius: "10px",
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              justifyContent: "flex-start",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={selectedDays.includes(
                                    moment(sailing_date)
                                      .add(index, "days")
                                      .format("YYYY-MM-DD")
                                  )}
                                />
                              }
                            />
                            <Box>
                              <Typography variant="subtitle1" fontWeight="bold">
                                Day {index + 1}
                              </Typography>
                              <p>
                                (
                                {moment(sailing_date)
                                  .add(index, "days")
                                  .format("YYYY-MM-DD")}
                                )
                              </p>
                            </Box>
                          </Box>
                        </Grid>
                      ))}
                  </Grid>
                </Box>

                {/* Select Time Slots */}
                <Box mb={2}>
                  <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                    Select Time Slots
                  </Typography>
                  {timeSlots.map((slot, index) => (
                    <Grid
                      container
                      spacing={1}
                      alignItems="center"
                      key={index}
                      mb={1}
                    >
                      <Grid item xs={5}>
                        <TextField
                          fullWidth
                          size="small"
                          type="time"
                          value={slot.startTime || ""}
                          label="Start Time"
                          onChange={(e) => {
                            const updatedSlots = [...timeSlots];
                            updatedSlots[index] = {
                              ...updatedSlots[index],
                              startTime: e.target.value,
                            };
                            setTimeSlots(updatedSlots);
                          }}
                          InputLabelProps={{ shrink: true }}
                          inputProps={{ step: 300 }}
                        />
                      </Grid>

                      <Grid item xs={5}>
                        <TextField
                          fullWidth
                          size="small"
                          label="End Time"
                          type="time"
                          value={slot.endTime || ""}
                          onChange={(e) => {
                            const updatedSlots = [...timeSlots];
                            updatedSlots[index] = {
                              ...updatedSlots[index],
                              endTime: e.target.value,
                            };
                            setTimeSlots(updatedSlots);
                          }}
                          InputLabelProps={{ shrink: true }}
                          inputProps={{ step: 300 }}
                          placeholder="End Time"
                        />
                      </Grid>

                      <Grid item xs={2}>
                        {index === timeSlots.length - 1 ? (
                          <IconButton color="primary" onClick={addTimeSlot}>
                            <AddIcon />
                          </IconButton>
                        ) : (
                          <IconButton
                            color="error"
                            onClick={() => removeTimeSlot(index)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                      </Grid>
                    </Grid>
                  ))}
                </Box>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={() => {
                    const invalidSlot = timeSlots.some(
                      (slot) => !slot.startTime || !slot.endTime
                    );
                    if (invalidSlot) {
                      message.error("Please select both Start Time and End Time for all slots.");
                      return;
                    }
                    handleAddData(selectedDays);
                  }}
                  sx={{ mt: 2, borderRadius: 2 }}
                >
                  Schedule for {selectedDays.length} Day(s) & {timeSlots.length} Time Slot(s)
                </Button>
              </Box>
            </Box>
          )}
        </Box>
        {/* Right Side */}
        <Box sx={{ border: "1px solid lightgray" }} p={2} flex={1}>
          <Typography variant="subtitle1" fontWeight="bold">
            Daily Schedule Overview
          </Typography>
          <Box>
            {assignedPages?.map((item, index) => (
              <Box key={item.day}>
                <div
                  onClick={() =>
                    activeDay == item.day
                      ? setActiveDay()
                      : setActiveDay(item.day)
                  }
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    cursor: "pointer",
                    background: "lightgray",
                    padding: "10px",
                    fontWeight: "bold",
                    height: "50px",
                    marginBottom: "10px",
                  }}
                >{`Day ${item.day} : (${moment(item.date).format(
                  "DD MMM YYYY"
                )})          ${item.activitiesCount} Listing(s)`}</div>
                {activeDay == item.day && (
                  <Box>
                    {item?.hourlySlots?.map((slot, slotIndex) => (
                      <Box
                        key={slotIndex}
                        style={{
                          border: "2px solid lightgray",
                          marginBottom: "10px",
                          padding: "5px",
                          display: "flex",
                          gap: "5px",
                        }}
                      >
                        <p style={{ width: "20%" }}>{getTime(slot.hour)}</p>
                        <div style={{ width: "80%" }}>
                          {slot?.schedule?.length == 0 && (
                            <p>No Activity Scheduled Yet</p>
                          )}
                          {slot?.schedule.map((activity, activityIndex) => (
                            <div
                              key={activityIndex}
                              style={{
                                background: "lightgray",
                                marginBottom: "10px",
                                padding: "10px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <div>
                                <p style={{ fontWeight: "bold" }}>
                                  {getTime(activity?.startTime)} -{" "}
                                  {getTime(activity.endTime)}
                                </p>
                                <p>
                                  {activity.pageName || activity?.venueName}
                                </p>
                              </div>
                              <DeleteIcon
                                onClick={() =>
                                  handleRemove(activity?.scheduleId)
                                }
                                style={{
                                  background: "red",
                                  color: "white",
                                  cursor: "pointer",
                                }}
                              />
                            </div>
                          ))}
                        </div>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DailyPlannerPageSelector;
